import { useGlobal } from '@/utils/useGlobal';
import EFPicture from 'elem/compCommon/EFPicture';
import { useRouter } from 'next/router';
import css from './index.module.scss';

export default function C() {
    const { useLang, useState, useEffect } = useGlobal();
    const { t } = useLang('RV');
    const { locale = 'us' } = useRouter();
    const IS_EU_SITES = ['eu', 'uk', 'de', 'fr', 'it', 'es'].includes(locale);

    const IMGS = IS_EU_SITES
        ? [
              'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717075015757/3_1.jpg',
              'https://websiteoss.ecoflow.com/upload/image/1744370181771/3_2.jpg',
              'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717075175556/3_3.jpg',
              'https://websiteoss.ecoflow.com/upload/image/1744370181950/3_4.jpg',
              'https://websiteoss.ecoflow.com/upload/image/1754385723617/PC_800w.jpg',
          ]
        : [
              'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717075015757/3_1.jpg',
              'https://websiteoss.ecoflow.com/upload/image/1744370181771/3_2.jpg',
              'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717075175556/3_3.jpg',
              'https://websiteoss.ecoflow.com/upload/image/1744370181950/3_4.jpg',
          ];
    const cards = Array.from({ length: IMGS.length }, (_, i) => i + 1);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const wrapper = document.querySelector('.RV-C .wrapper') as HTMLDivElement;
            const swiper = document.querySelector('.RV-C .swiper-box') as HTMLDivElement;
            AniContainer.create({
                syncFromTo: [['.RV-C .swiper-box', { x: 0 }, { x: wrapper?.offsetWidth - swiper?.offsetWidth }]],
                triggerElement: '.RV-C',
                triggerHook: 1,
                offset: '120%',
                duration: '230%',
            });
        }
    }, []);

    return (
        <div id="RV-C" className={`RV-C RV-box ${css['RV-C']}`}>
            <div className="sticky">
                <div className="inner-box">
                    <div className="info-box">
                        <p className="title">{t('C_title')}</p>
                    </div>
                    {/* <Swiper className="cards swiper-box" spaceBetween={gap} slidesPerView={'auto'} initialSlide={0}> */}
                    <div className="wrapper">
                        <ul className="swiper-box">
                            {cards?.map((k: number) => (
                                // <SwiperSlide className="swiper-item" key={k}>
                                <li className="swiper-item" key={k}>
                                    <div className="card-img">
                                        <EFPicture src={IMGS[k - 1]} alt={t(`C_card${k}_title`)} />
                                    </div>
                                    <p className="card-title">
                                        {t.rich(`C_card${k}_title`, {
                                            n: (text: strnig) => <span className="no-wrap">{text}</span>,
                                        })}
                                    </p>
                                    <p className="card-desc">
                                        {t.rich(`C_card${k}_desc`, {
                                            n: (text: strnig) => <span className="no-wrap">{text}</span>,
                                            sup: (text: strnig) => <sup>{text}</sup>,
                                        })}
                                    </p>
                                </li>
                                // </SwiperSlide>
                            ))}
                        </ul>
                    </div>
                    {/* </Swiper> */}
                </div>
            </div>
        </div>
    );
}
